<template>
  <AppPageContainer :custom="1600" :min-height="0">
    <AppPageHeader design="new" title="Lead Flow" compact />
    <AppTabs design="new" refined weight="medium" :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </AppPageContainer>
</template>

<script>
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'LeadFlowLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'crm-task-tracker', label: 'Task Tracker' },
        { name: 'crm-task-tracker-leads', label: 'Leads' },
        { name: 'crm-task-tracker-double-requests', label: 'Double Requests' }
      ]
    }
  }
}
</script>
